module.exports = __webpack_public_path__ + "static/media/value5.b83a1401.svg";